import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=13a31e4c&scoped=true&"
import script from "./MediaList.vue?vue&type=script&lang=js&"
export * from "./MediaList.vue?vue&type=script&lang=js&"
import style0 from "./MediaList.vue?vue&type=style&index=0&id=13a31e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a31e4c",
  null
  
)

export default component.exports